{
  "page": {
    "intro": "送り先・送料・配送会社・輸入関税の設定です。お客さまにはここで決めたとおりに表示されます。",
    "read_only": "この設定は見るだけです。変更できるのはオーナーだけです。"
  },
  "tabs": {
    "label": "配送の設定",
    "zones": "送り先",
    "carriers": "配送会社",
    "duties": "輸入関税",
    "packaging": "梱包",
    "calculator": "送料を試す"
  },
  "lang": {
    "en": "英語",
    "ja": "日本語",
    "th": "タイ語",
    "zh-Hant": "中国語（繁体字）",
    "zh-Hans": "中国語（簡体字）",
    "en_hint": "空欄の言語ではこの英語が使われます。"
  },
  "zones": {
    "intro": "ゾーンは同じ配送方法を使う地域のまとまりです。国（または都道府県）は1つのゾーンにしか入れられません。",
    "add": "ゾーンを追加",
    "start_from": "ここから始める",
    "start_empty": "空のゾーン（国を自分で選ぶ）",
    "rest_of_world": "その他の国（まだゾーンにない国すべて）",
    "countries_count_other": "{{count}}か国",
    "more_other": "ほか{{count}}",
    "empty_title": "ゾーンがまだありません",
    "empty_body": "まず日本のゾーンを作り、次に送る国のまとまりごとにゾーンを作ってください。",
    "load_failed": "ゾーンを読み込めませんでした",
    "on": "お客さまが選べます",
    "off": "停止中",
    "edit": "地域を変更",
    "view": "地域を見る",
    "rates_of": "{{zone}}への配送方法",
    "no_rates": "配送方法がまだありません。追加するまで、このゾーンのお客さまは注文できません。",
    "upcoming": "後日から変わる送料",
    "past_other": "以前の送料 {{count}}件（注文済みの分のため保存）",
    "carriers_all": "配送会社：すべて",
    "carriers_some": "配送会社：{{names}}"
  },
  "zone": {
    "new": "新しいゾーン",
    "new_from": "新しいゾーン：{{name}}",
    "description": "このゾーンの国と、日本の場合は全国か一部の都道府県か。",
    "name": "ゾーン名",
    "name_required": "英語の名前を入れてください（空欄の言語で使われます）。",
    "countries_other": "このゾーンの国（{{count}}）",
    "chosen": "選んだ国",
    "no_countries": "まだ国を選んでいません。",
    "remove_country": "{{name}}を外す",
    "search_country": "国を探す",
    "countries_required": "国を1つ以上選んでください。",
    "japan_part": "日本のどこか",
    "japan_all": "日本全国",
    "japan_some": "一部の都道府県だけ（別料金。例：沖縄県）",
    "prefectures": "都道府県",
    "regions_required": "都道府県を1つ以上選ぶか、「日本全国」を選んでください。",
    "left_out": "ほかのゾーンにあるため外しました：{{places}}",
    "active": "お客さまがこのゾーンを選べる",
    "active_hint": "オフにすると、何も消さずに提供を止められます。",
    "note": "店用メモ（お客さまには見えません）",
    "save": "ゾーンを保存",
    "created": "ゾーンを追加しました",
    "saved": "ゾーンを保存しました",
    "delete": "ゾーンを削除",
    "delete_title": "ゾーン「{{name}}」を削除しますか？",
    "delete_body": "この地域のお客さまは注文できなくなります。注文済みの送料はそのままです。",
    "cannot_delete_title": "{{name}}にはまだ配送方法があります",
    "cannot_delete_body_other": "配送方法が{{count}}件あるため削除できません。代わりに停止してください。お客さまに表示されなくなり、注文済みの送料はそのままです。",
    "switch_off": "ゾーンを停止する",
    "switched_off": "ゾーンを停止しました",
    "deleted": "ゾーンを削除しました",
    "carriers": "このエリアで使う配送会社",
    "carriers_all": "すべての会社",
    "carriers_some": "チェックした会社だけ",
    "carriers_hint": "チェックしていない会社の送り方は保存されたままですが、このエリアのお客様には表示されません。",
    "carriers_required": "配送会社を1つ以上チェックするか、「すべての会社」を選んでください。"
  },
  "rate": {
    "add": "配送方法を追加",
    "new_in": "新しい配送方法 — {{zone}}",
    "description": "送料は税込で、店が決めた金額です。安い順にお客さまに表示されます。",
    "edit": "変更",
    "view": "見る",
    "save": "保存",
    "created": "配送方法を追加しました",
    "saved": "配送方法を保存しました",
    "off": "（停止中）",
    "name": "お客さまに見える名前",
    "carrier": "配送会社",
    "how_priced": "送料の決め方",
    "type": {
      "flat": "一律",
      "weight": "重さで決める",
      "price": "注文金額で決める",
      "free_over": "一定額以上で無料",
      "pickup": "店頭受け取り"
    },
    "type_hint": {
      "flat": "どの荷物も同じ送料（例：クリックポスト）。",
      "weight": "重さの段階ごとの送料（例：ゆうパック）。",
      "price": "注文金額の段階ごとの送料。",
      "free_over": "送料あり、注文金額が一定額に届くと無料。"
    },
    "price": "送料",
    "free_from": "無料になる注文金額",
    "free_from_hint": "割引後の注文金額です。",
    "tiers_weight": "重さごとの送料",
    "tiers_weight_hint": "軽い順に。荷物は入る最初の段階を使います。最後の段階より重いと表示されません。",
    "tiers_price": "注文金額ごとの送料",
    "tiers_price_hint": "少ない金額から順に。最後の行の「まで」を空欄にすると「それ以上」です。",
    "tier_up_to_g": "{{row}}行目：何グラムまで",
    "tier_up_to_yen": "{{row}}行目：注文金額いくらまで",
    "tier_last_hint": "空欄＝それ以上",
    "tier_price": "{{row}}行目：送料",
    "tier_remove": "{{row}}行目を削除",
    "tier_add": "行を追加",
    "max_weight": "最大の重さ",
    "max_weight_hint": "空欄＝この方法独自の上限なし。",
    "eta_min": "お届け日数（早い場合）",
    "eta_max": "お届け日数（遅い場合）",
    "days": "日",
    "eta_days": "{{min}}〜{{max}}日",
    "protection": "追跡と補償",
    "tracked": "追跡番号あり",
    "insured": "補償あり（紛失・破損時に配送会社が補償）",
    "insured_rule": "{{amount}}以上の注文には補償ありの方法だけが表示されます。",
    "coverage": "補償額の上限",
    "coverage_hint": "空欄＝全額。",
    "can_add_insurance": "追加の保険をかけられる",
    "signature": "受け取りにサインが必要",
    "more": "その他の設定",
    "service_level": "サービスの種類",
    "service_level_none": "設定なし",
    "service_tier": {
      "economy_tracked": "安い・追跡あり",
      "standard_insured": "標準・補償あり",
      "express_courier": "速達（クーリエ）"
    },
    "duties_default": "輸入関税（この方法の基本）",
    "duties_default_hint": "郵便で米国へ$100〜2,500の荷物は、いつも店が前払いします（システムが自動で設定）。",
    "min_subtotal": "この注文金額から使える",
    "max_subtotal": "この注文金額まで使える",
    "max_declared": "送れる品物の最大価格",
    "starts_on": "この送料の開始日",
    "starts_on_hint": "空欄＝今日から。後の日付にすると、その日までは今の送料のままです。",
    "active": "お客さまが選べる",
    "active_hint": "オフにすると、削除せずに提供を止められます。",
    "notes": "店用メモ",
    "notes_hint": "例：料金の出典。お客さまには見えません。",
    "starts": "{{date}}から",
    "badge": {
      "insured": "補償あり",
      "signature": "サイン",
      "untracked": "追跡なし",
      "unverified": "料金未確認",
      "max_thickness": "厚さ {{mm}} mm まで",
      "carrier_off": "このエリアでは会社がオフ — お客様に表示されません"
    },
    "summary": {
      "up_to": "{{limit}}まで {{price}}",
      "above": "それ以上：{{price}}",
      "free_over": "{{price}}、{{from}}以上で無料"
    },
    "delete": "削除",
    "delete_named": "{{name}}を削除",
    "delete_title": "{{name}}を削除しますか？",
    "delete_consequence": "お客さまは選べなくなります。注文済みの送料はそのままです。",
    "deleted": "配送方法を削除しました",
    "problem": {
      "fix_marked": "印のついた欄を直してください。",
      "name_en": "英語の名前を入れてください（空欄の言語で使われます）。",
      "carrier": "配送会社を選んでください。",
      "price": "送料を円（整数）で入れてください。",
      "tiers_empty": "送料のある行を1つ以上追加してください。",
      "tiers_weight": "各行にグラム数と送料（円・整数）が必要です。",
      "tiers_price": "各行に送料が必要です。「まで」を空欄にできるのは最後の行だけです。",
      "free_over": "送料が無料になる注文金額を入れてください。",
      "numbers": "重さと金額は整数で入れてください。",
      "eta": "日数は整数で、早い場合が遅い場合より大きくならないようにしてください。"
    },
    "max_thickness": "荷物の厚さの上限",
    "max_thickness_hint": "ポスト投函の送り方は 30 mm（3 cm）。空欄 = 上限なし。"
  },
  "grid": {
    "open": "重さ別の送料をまとめて入力",
    "title": "重さ別の送料 — {{zone}}",
    "description": "送料を入力してください。空欄はその重さの段階がないという意味です。",
    "way": "配送方法",
    "up_to": "{{weight}}まで",
    "cell": "{{name}}、{{weight}}まで",
    "hint": "荷物は入る最初の段階を使います。重い段階を安くすることはできません。",
    "add_weight": "重さの段階を追加（グラム）",
    "add_weight_button": "段階を追加",
    "weight_invalid": "1〜30,000グラムで入れてください。",
    "whole_yen": "送料は円（整数）で入れてください。",
    "download": "表計算用にダウンロード",
    "upload": "表計算のファイルを読み込む",
    "csv_unreadable": "このファイルには「code」の列か重さの列がありません。先に表をダウンロードして、そのファイルに入力してください。",
    "csv_unknown": "この表にないため外しました：{{codes}}",
    "save": "送料を保存",
    "saved_other": "{{count}}件の配送方法を保存しました",
    "some_failed_other": "{{count}}行が保存されませんでした。赤い文字を見てください。"
  },
  "carrier": {
    "intro": "お客さまへのメールの追跡リンクは、ここで設定したページを開きます。配送会社の公式サイトである必要があります。",
    "load_failed": "配送会社を読み込めませんでした",
    "domestic": "国内",
    "international": "海外",
    "insurable": "補償あり",
    "customs": "税関書類が必要",
    "changed_by_shop": "店で変更済み",
    "on": "使用中",
    "off": "使わない",
    "use": "この会社を使う",
    "warning_ignored": "店の変更が使えなかったため（サイト違い）、標準のページを使っています。",
    "page": "追跡ページ",
    "page_hint": "配送会社のサイトの https で、番号が入る所に {n} を入れます。",
    "sample": "試す番号",
    "sample_hint": "例：{{example}}",
    "test": "{{name}}の追跡ページを開く",
    "test_unavailable": "このページは使えません：配送会社のサイトの https で、{n} を1回入れてください。",
    "save_page": "追跡ページを保存",
    "back_to_default": "標準のページに戻す",
    "saved": "{{name}}を保存しました",
    "template_refused": "このページは使えません。配送会社のサイトの https で、{n} を1回入れてください。"
  },
  "duties": {
    "intro": "市場ごとに輸入関税を誰が払うかと、チェックアウトの概算に使う税率です。税率はよく変わるので、ここで変えるとすぐ使われます。",
    "source": "調査：日本からの米国向けカードの関税は2026-07-24から約12.5%（2026-09-24確認、法令の文面では未確認）— {{file}}。発送前に Zonos／税関で確認してください。",
    "no_access": "輸入関税は税金の設定にあります",
    "no_access_body": "オーナーかマネージャーにこのページを開いてもらってください。",
    "load_failed": "市場を読み込めませんでした",
    "every_other_country": "その他のすべての国",
    "updated": "最終変更",
    "us_rule": "米国・郵便で$100〜2,500：関税は前払い（DDP、Zonos経由）が必要です。システムが自動で適用します。",
    "who_pays": "輸入関税を払う人",
    "mode": {
      "DDU": "お客さまが受け取り時に払う（DDU）",
      "DDP": "店が前払いする（DDP）"
    },
    "mode_hint": {
      "DDU": "配送会社からお客さまに関税と手数料を請求されることがあります。",
      "DDP": "チェックアウトに概算が表示され、店が発送前に払います。"
    },
    "percent": "関税率",
    "percent_hint": "空欄＝概算なし。小数3桁まで。例：12.5",
    "percent_invalid": "0〜100の数で入れてください。例：12.5",
    "notice": "チェックアウトでお客さまが読む文",
    "notice_hint": "空欄＝この選択の店の標準の文。",
    "save": "関税を保存",
    "saved": "{{name}}の関税を保存しました",
    "confirm_title": "{{name}}の関税を変更しますか？",
    "confirm_body": "新しいチェックアウトにすぐ反映されます。",
    "confirm_percent": "税率：{{percent}}%",
    "confirm_no_percent": "税率なし（概算なし）"
  },
  "packaging": {
    "intro": "荷物の重さと厚さを出すために、システムが毎回足す数字です（チェックアウトと同じ）。変更すると次のお客様からすぐ使われます。",
    "load_failed": "梱包の重さを読み込めませんでした",
    "box": "荷物1つの梱包",
    "box_hint": "箱・緩衝材・詰め物。",
    "pack": {
      "raw_single": "カード1枚（スリーブ＋トップローダー＋チームバッグ）— カードに重さがない場合。",
      "graded_single": "鑑定済みカード1枚（スラブスリーブ＋硬い箱＋緩衝材）。",
      "sealed_product": "未開封のボックス・パック1つ — 重さがない場合。",
      "supplies": "サプライ1つ — 重さがない場合。"
    },
    "insured_from": "補償ありの方法だけになる金額",
    "insured_from_hint": "この金額以上の注文には補償ありの方法だけが表示されます（サインと荷物の写真をおすすめします）。",
    "read_only": "この数字を変えられるのは、ストア設定を変更できる人だけです。",
    "weight": "梱包材の重さ",
    "thickness": "梱包材の厚さ",
    "weight_one": "1点の重さ",
    "thickness_one": "1点の厚さ（梱包後）",
    "start_value": "初期値：{{value}}",
    "thickness_note": "厚さで 3 cm までの送り方（クリックポスト・ゆうパケット・レターパックライト）が使えるか決まります。初期値は目安です。梱包した荷物を測って入力してください。",
    "save": "保存",
    "saved": "保存しました — 次のお客様から新しい送料になります",
    "reset": "初期値に戻す",
    "conflict": "たった今ほかの人がこの数字を保存しました。触っていない欄はその数字に変わりました。入力した数字はそのまま残っていますが、まだ保存されていません（各欄の下に今保存されている数字を表示）。自分の数字にするなら保存、保存済みの数字にするなら下のボタンを押してください。",
    "problem": {
      "number": "決められた範囲の整数を入力してください。",
      "summary_other": "{{count}}か所に、決められた範囲の整数を入力してください（赤い文字の欄）。"
    },
    "saved_now": "今保存されている数字：{{value}}",
    "take_saved": "保存済みの数字を使う"
  },
  "product_type": {
    "raw_single": "カード（未鑑定）",
    "graded_single": "鑑定済みカード",
    "sealed_product": "未開封ボックス・パック",
    "supplies": "サプライ"
  },
  "calc": {
    "form": "試す内容",
    "intro": "送り先と品物を選ぶと、お客さまに見えるとおりの一覧が出ます。注文も取り置きもされません。",
    "how": "受け取り方",
    "method": {
      "ship": "配送",
      "pickup": "店頭受け取り"
    },
    "country": "国",
    "prefecture": "都道府県",
    "prefecture_any": "指定なし",
    "lookup": "店のカード・ボックス（コードをスキャンか入力）",
    "lookup_button": "追加",
    "lookup_hint": "価格と重さが入ります。",
    "not_found": "このコードの商品はありません。",
    "item": "品物 {{row}}",
    "kind": "種類",
    "qty": "数",
    "pieces": "点",
    "price": "品物 {{row}}：価格",
    "weight": "1つの重さ",
    "weight_hint": "空欄＝標準の重さ（梱包タブ）。",
    "export_price": "税抜価格（輸出用）",
    "export_price_hint": "関税の概算に必要です。",
    "add_item": "品物を追加",
    "remove_item": "品物 {{row}} を外す",
    "result": "お客さまに見えるもの",
    "fill_in": "価格を入れると配送方法が表示されます。",
    "zone": "ゾーン",
    "pickup": "店頭受け取り",
    "parcel_weight": "荷物の重さ",
    "value": "品物の価格",
    "notices": "チェックアウトのお知らせ",
    "options": "配送方法（安い順）",
    "free": "送料無料",
    "insured_up_to": "{{amount}}まで補償",
    "duty_estimate": "関税の概算 {{amount}}",
    "hidden": "この荷物には表示されない方法",
    "hidden_row": "{{name}} — {{reason}}",
    "hidden_reason": {
      "insurance_required": "補償なし（高額な注文）",
      "declared_value_too_high": "品物の価格が上限を超える",
      "too_heavy": "重すぎる",
      "subtotal_out_of_range": "注文金額が対象外",
      "too_thick": "厚すぎる",
      "carrier_off": "このエリアでは会社がオフ"
    },
    "thickness": "1点の厚さ",
    "thickness_hint": "空欄 = 標準の厚さ（梱包タブ）",
    "parcel_thickness": "荷物の厚さ"
  },
  "notice": {
    "checkout_ddp_us_notice": "米国：輸入関税は店が前払いします（表示価格に含む）。",
    "checkout_ddu_notice": "受け取り時に輸入関税と手数料がかかることがあります。",
    "checkout_duties_estimate_unavailable": "関税の概算なし：税抜価格のない品物があります。",
    "checkout_duties_us_ddp": "米国：輸入関税は店が前払いします。",
    "checkout_duties_ddu": "受け取り時に輸入関税と手数料がかかることがあります。",
    "checkout_duties_uk_135": "英国：£135までの注文には VAT が加わります。",
    "shipping_insurance_required": "{{threshold}}以上の注文は補償ありの方法でのみ送ります。",
    "shipping_free_shipping_applied": "送料無料が適用されました。",
    "other": "関税または配送についてのお知らせがお客さまに表示されます。"
  },
  "problem": {
    "zone_conflict": "ゾーン {{zone}} にすでに入っています：{{places}}。先にそちらから外すか、そのゾーンを停止してください。",
    "zone_has_rates": "このゾーンにはまだ配送方法があります。先に削除するか、ゾーンを停止してください。",
    "unknown_prefecture": "不明な都道府県：{{value}}",
    "rate": {
      "thresholds_not_ascending": "{{row}}行目：「まで」は上の行より大きくしてください（段階が重なっています）。",
      "price_decreases_with_weight": "{{row}}行目：重い段階を上の行より安くすることはできません。",
      "threshold_required": "{{row}}行目：「まで」の重さか金額を入れてください。",
      "required_for_type": "送料のある行を1つ以上追加してください。",
      "unknown_carrier": "この配送会社はありません。別の会社を選んでください。",
      "greater_than_max": "小さい方の数が大きい方の数を超えています。",
      "before_effective_from": "終了日が開始日より前です。"
    },
    "quote": {
      "no_zone": "この地域を含むゾーンがないため、この地域のお客さまは注文できません。",
      "no_rates": "このゾーンにはまだ配送方法がありません。",
      "all_rates_hidden": "この荷物に合う配送方法がありません（高額・重すぎ・注文金額が対象外）。",
      "no_pickup_location": "店頭受け取りの店が設定されていません。",
      "too_heavy": "荷物（{{weight}} g）がどの配送方法の上限（{{max}} g）より重いです。"
    }
  }
}
